import { SnackbarVariant } from '@elementary/common-ui/components';
import { Report } from '@elementary/common-ui/types';
import { atom } from 'recoil';
import { DashboardData } from '@/dashboard/useDashboard';

export const snackbar = atom<{
  open: boolean;
  variant?: SnackbarVariant;
  message?: string;
}>({
  key: 'snackbar',
  default: { open: false },
});

export const report = atom<Report>({
  key: 'report',
  default: undefined,
});

export const dashboardDataCache = atom<
  Record<string, DashboardData | undefined>
>({
  key: 'dashboardDataCache',
  default: {},
});
